
import "./assets/css/bootstrap.min.css";
import "./assets/css/animate.css";
import "./assets/css/icons.css";
import "./assets/css/metisMenu.min.css";
import "./assets/css/extra.css";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import styled, { keyframes } from "styled-components";
import { Event, decode, encode, wait, isMobile, sendNotfication } from 'utils/Helper';
import WalletAlert from "./components/User/Wallet/Alert";
import C from 'utils/Constant';
import storage from "utils/Storage";
import socket from "utils/Socket";
import { useWebsiteConfigQuery } from "hooks/useWebsiteConfig";

import "./app.css";
import "./layout.css";
import "./games.css";

const SIDEBAR_WIDTH = 239;
const HEADER_HEIGHT = 60;

const AppContainer = styled.div`
  display: flex;
  background-color: #232626;
  color: white;
  font-family: Arial, sans-serif;
`;

const MainArea = styled.div`
  flex: 1;
  padding-top: 60px;
  min-height: 100vh;
  width: calc(100vw - ${SIDEBAR_WIDTH}px);
  overflow-x: hidden;
  z-index: -1 important;
  margin-left: ${(props) =>
    props.isSmallScreen ? "0px" : props.isCollapsed ? "86px" : "242px"};
  transition: margin-left 0.3s ease;

  @media (max-width: 576px) {
    padding-top: 0px;
  }
`;

const scrollMarquee = keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-50%, 0, 0);
  }
`;

const MarqueeContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 28px;
  background-color: #17181b;
  border-top: 1px solid rgba(245, 158, 11, 0.35);
  z-index: 999999;
  display: flex;
  align-items: center;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 11px;
  color: #9ca3af;
  font-weight: 500;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.5);
  user-select: none;
  letter-spacing: 0.3px;
`;

const MarqueeTrack = styled.div`
  display: flex;
  width: max-content;
  animation: ${scrollMarquee} 35s linear infinite;
`;

const MarqueeText = styled.span`
  padding: 0 60px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ContentContainer = styled.div`
  padding: 10px;
  padding-bottom: 40px;
  min-height: calc(100vh - ${HEADER_HEIGHT}px);
`;

const HeaderMainConatiner = styled.div`
  position: fixed;
  top: 0;
  left: ${(props) =>
    props.isSmallScreen ? "0px" : props.isCollapsed ? "0px" : "0px"};
  right: 0;
  z-index: 666;
  width: 100% !important;
`;

const Index = ({ t, location, get_wallet, content }) => {
  const { data: config } = useWebsiteConfigQuery();
  const isTestingMode = config ? config.is_testing_mode !== false : true;

  const [auth, setAuth] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isCollapsedMobile, setIsCollapsedMobile] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    socket.on(C.ONLINE, (status) => onlineUser(decode(status)));

    Event.on("showAuthModal", () => {
      sendNotfication(
        "Please Login or Register !",
        "success",
        "bottom-left",
        true
      );
    });

    Event.on("logout", () => {
      setAuth(false);
    });

    Event.on("login", () => {
      setAuth(true);
    });

    const sessionCookie = Cookies.get("session");
    if (sessionCookie) {
      socket.emit(
        C.ONLINE,
        encode({
          jwt_token: storage.getKey("jwt_token"),
          user_token: storage.getKey("user_token"),
          security_key: storage.getKey("security_key"),
          secret_user: storage.getKey("secret_user"),
          secret_realtime: storage.getKey("secret_realtime"),
          client_system: storage.getKey("client_system"),
          token_key: storage.getKey("token_key"),
          secret_token: storage.getKey("secret_token"),
        })
      );
    }

    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onlineUser = (data) => {
    wait(500).then(() => {
      if (data.status === true) {
        storage.setKey("logged", true);
        Cookies.set("uid", data.id, { expires: 14, path: '/' });
        Cookies.set("auth", true, { expires: 14, path: '/' });
        storage.setKey("name", data.name);
        storage.setKey("email", data.email);
        storage.setKey("credit", data.credit);
        storage.setKey("avatar", data.avatar);
        storage.setKey("friends", data.friends);
        storage.setKey("room", data.room);
        setAuth(true);
      } else {
        wait(1000).then(() => {
          localStorage.clear();
          setAuth(false);
        });
      }
    });
  };

  let wallet;
  try {
    wallet = get_wallet.show;
  } catch (e) {}

  return (
    <>
      <AppContainer>
        <Sidebar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          isCollapsedMobile={isCollapsedMobile}
          setIsCollapsedMobile={setIsCollapsedMobile}
          isSmallScreen={isSmallScreen}
        />
        <MainArea isSmallScreen={isSmallScreen} isCollapsed={isCollapsed}>
          <HeaderMainConatiner
            isSmallScreen={isSmallScreen}
            isCollapsed={isCollapsed}
          >
            <Header 
               isCollapsedMobile={isCollapsedMobile}
               setIsCollapsedMobile={setIsCollapsedMobile}
               isAuthed={storage.getKey("logged") || auth}
            />
          </HeaderMainConatiner>
          <ContentContainer
            isSmallScreen={isSmallScreen}
            isCollapsed={isCollapsed}
          >
            {wallet && <WalletAlert t={t} uid={get_wallet?.uid} />}
            {content}
          </ContentContainer>
          <Footer />
        </MainArea>
      </AppContainer>
      {isTestingMode && (
        <MarqueeContainer>
          <MarqueeTrack>
            <MarqueeText>
              <span style={{ fontSize: '12px', marginRight: '4px' }}>⚠️</span> <strong style={{ color: '#fbbf24' }}>Disclaimer:</strong> This game demo is not intended for users within India. Due to the Gaming Act 2025 regulations, it is provided solely for demonstration purposes to international clients interested in development services.
            </MarqueeText>
            <MarqueeText>
              <span style={{ fontSize: '12px', marginRight: '4px' }}>⚠️</span> <strong style={{ color: '#fbbf24' }}>Disclaimer:</strong> This game demo is not intended for users within India. Due to the Gaming Act 2025 regulations, it is provided solely for demonstration purposes to international clients interested in development services.
            </MarqueeText>
          </MarqueeTrack>
        </MarqueeContainer>
      )}
    </>
  );
};

Index.propTypes = {
  get_wallet: PropTypes.any,
};

const mapStateToProps = (state) => ({
  get_wallet: state.items.get_wallet,
});

export default connect(mapStateToProps, null)(Index);
